import {ajax} from '../../common/controller/ajaxCtrl';
import Provider from '../../common/model/Provider';

function isNotEmpty(value){
    if(value === undefined){
        value = "";
    }else if(value == null){
        value = "";
    }
    return value;
}

export function appendHistory(target, res){
    const json = JSON.parse(res);
    const keys = Object.keys(json);
    var jsonArr = []
    for(var i=0; i<keys.length; i++){
        var key = keys[i];
        var value = json[key];
        if(typeof value !== "object"){
            jsonArr.push({key:key, value:value})
        }
    } 
    var tmpl = require('../html/demoHistoryTable.hbs');
    var html = tmpl({list:jsonArr});

    var row = "<div class='demo-history-row'>"+html+"</div>"
    $(`#oacx-demo-main #${target}`).html(row);

    $(`#oacx-demo-main #${target} a[data-id=token]`).on('click',function(e){
        var token = $(e.currentTarget).text();
        ajax.parseToken(token).then(res =>{
            var json = {
                title: "토큰 확인",
                data: JSON.stringify(res)
            }
            template(json);
        },res=>{})
    })

    $("#oacx-demo-main a[data-id=signedData]").on('click',function(e){
        var txId = Provider.txId;
        var signTarget = Provider.contentInfo.signTarget
        var signedData = $("#oacx-demo-main #auth2Log a[data-id=signedData]").text();
        var json = {
            txId: isNotEmpty(txId),
            signTarget: isNotEmpty(signTarget),
            signedData: isNotEmpty(signedData)
        };
        var params = `txId=${json.txId}&signTarget=${json.signTarget}&signedData=${json.signedData}`
        ajax.parseSignData(params).then(res =>{
            var json = {
                title: "서명 데이터 확인",
                data: JSON.stringify(res).replace(/\\n/g,'').replace(/\\r/g,'')
            }
            template(json);
        },res=>{})
    })

}

function template(json){
    var tmpl = require('../html/popup.demo.confirm.hbs');
    var html = tmpl(json);
    $("#oacx-demo-main #confirmPopup").remove();
    $("#oacx-demo-main").prepend(html);
    $("#confirmPopup_confirm").on('click', function(e){
        $("#oacx-demo-main #confirmPopup").remove();
    })
}

const oacx_demo = {
    init: ()=>{
        oacx_demo.selectBtn();
    },
    selectBtn: ()=>{
        $(".demo-header li a").on('click',function(e){
            $(".demo-header li a").removeClass("demo-select");
            $(e.currentTarget).addClass("demo-select");
        
            var id = $(e.currentTarget).attr("data-id");
            $(".demo-cst-content").hide();
            $("div[data-content="+id+"]").show();
        })

        $(".log-header li a").on('click',function(e){
            $(".log-header li a").removeClass("log-select");
            $(e.currentTarget).addClass("log-select");
        
            var id = $(e.currentTarget).attr("data-id");
            $(".log-tab").hide();
            $("div[data-logcontent="+id+"]").show();
        })

    }
}


//--------
oacx_demo.init();
//--------
